import styled from 'styled-components';


export const Container = styled.div`
    iframe {
        margin-top: 20px;
        border: none;

    }
`